import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

/** Chain Lightning: who the bolts leap to, from the creatures within reach of the first target. */
export default function ChainTargetPrompt({ name, options, limit, resolve }) {
  const [picked, setPicked] = useState([]);
  const toggle = id => setPicked(old => (old.includes(id) ? old.filter(item => item !== id) : old.length < limit ? [...old, id] : old));
  return <Modal show centered backdrop="static" keyboard={false} className="dnd-modal modern-modal" aria-label={name}>
    <Modal.Header><Modal.Title>{name}</Modal.Title></Modal.Header>
    <Modal.Body>
      <p>Choose up to {limit} more targets: {picked.length} chosen.</p>
      {options.map(option => <Form.Check key={option.id} id={`chain-${option.id}`} type="checkbox" label={`${option.name} · ${option.feet} feet`} checked={picked.includes(option.id)}
        disabled={!picked.includes(option.id) && picked.length >= limit} onChange={() => toggle(option.id)} />)}
    </Modal.Body>
    <Modal.Footer><Button onClick={() => resolve(picked)}>Cast</Button></Modal.Footer>
  </Modal>;
}
